import React from "react";
import axios from "axios";
import { connect } from "react-redux";

import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

import { FreeBreakfast } from "@mui/icons-material";

import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import CardHeader from "../../../components/Card/CardHeader";
import CardIcon from "../../../components/Card/CardIcon";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import { formatValuta } from "../../../utils";
import Filters from "../Components/Filters";

import * as actions from "../../../store/actions";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

import { withStyles } from "tss-react/mui";
import rapportenStyle from "../../../assets/jss/material-dashboard-pro-react/views/rapportenStyle";
import { toast } from "react-toastify";
import { format } from "date-fns";

class Tafels extends React.Component {
  state = {
    salesTafelsOverPeriode: {
      items: {},
      totalen: {
        waarde: 0,
        aantal: 0,
      },
    },
  };

  currentRequest;

  getData = (filterData) => {
    toast.info(<TranslationWrapper tDefault={"laden"} tKey={"global.laden"} />);

    let data = {
      vestiging_ids: filterData.vestiging_ids,
      start_datum: format(new Date(filterData.start_datum), "yyyy-M-d HH:mm:ss"),
      eind_datum: format(new Date(filterData.eind_datum), "yyyy-M-d HH:mm:ss"),
      preordertimes: filterData.preordertimes,
    };

    if (this.currentRequest !== undefined) {
      this.currentRequest.cancel();
    }

    const CancelToken = axios.CancelToken;
    this.currentRequest = CancelToken.source();
    let cancelToken = this.currentRequest.token;

    axios
      .post("core/rapporten/sales_tafels_genereer", data, {
        cancelToken: cancelToken,
      })
      .then((response) => {
        let newState = { ...this.state, ...response.data.data };
        this.setState(newState);
      })
      .catch((error) => {
        /**
         * Alleen niet CANCEL errors afvangen
         */
        if (!error.__CANCEL__) {
          toast.error(
            <TranslationWrapper tDefault={"Oeps er is iets misgegaan!"} tKey={"global.rapporten.errormessage"} />
          );
        }
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Filters onFilterChange={this.getData} showEndDate showPreordertimes showStartDate showVestigingen />
        <GridContainer>
          <GridItem lg={12} md={12} sm={12} xs={12}>
            <Card>
              <CardHeader color={"primary"} icon>
                <CardIcon color={"primary"}>
                  <FreeBreakfast />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  <TranslationWrapper
                    tDefault={"Tafel overzicht over periode"}
                    tKey={"rapportages.rapporten.tafels.overzichtPeriode"}
                  />
                </h4>
              </CardHeader>
              <CardBody>
                <div className={classes.tableResponsive}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <TranslationWrapper
                            tDefault={"Locatie"}
                            tKey={"rapportages.rapporten.tafels.table.locatie"}
                          />
                        </TableCell>
                        <TableCell />
                        <TableCell />
                        <TableCell />
                        <TableCell>
                          <TranslationWrapper tDefault={"Tafel"} tKey={"rapportages.rapporten.tafels.table.tafel"} />
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper tDefault={"Aantal"} tKey={"rapportages.rapporten.tafels.table.aantal"} />
                        </TableCell>
                        <TableCell>
                          <TranslationWrapper tDefault={"Bedrag"} tKey={"rapportages.rapporten.tafels.table.bedrag"} />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.keys(this.state.salesTafelsOverPeriode.items).map((prop, key) => {
                        return [
                          <TableRow key={key + "0"} style={{ backgroundColor: "#ff9800" }}>
                            <TableCell colSpan={"4"}>
                              {this.state.salesTafelsOverPeriode.items[prop].vestiging}
                            </TableCell>
                            <TableCell>{this.state.salesTafelsOverPeriode.items[prop].naam}</TableCell>
                            <TableCell>{this.state.salesTafelsOverPeriode.items[prop].aantal}</TableCell>
                            <TableCell>
                              {formatValuta(this.state.salesTafelsOverPeriode.items[prop].orderValue)}
                            </TableCell>
                          </TableRow>,
                          <TableRow key={key + 1}>
                            <TableCell>
                              <b>
                                <TranslationWrapper
                                  tDefault={"ORDER #"}
                                  tKey={"rapportages.rapporten.tafels.table.orderId"}
                                />
                              </b>
                            </TableCell>
                            <TableCell>
                              <b>
                                <TranslationWrapper
                                  tDefault={"Producten"}
                                  tKey={"rapportages.rapporten.tafels.table.producten"}
                                />
                              </b>
                            </TableCell>
                            <TableCell>
                              <b>
                                <TranslationWrapper
                                  tDefault={"Aantal"}
                                  tKey={"rapportages.rapporten.tafels.table.aantal"}
                                />
                              </b>
                            </TableCell>
                            <TableCell>
                              <b>
                                <TranslationWrapper
                                  tDefault={"Regeltotaal"}
                                  tKey={"rapportages.rapporten.tafels.table.regeltotaal"}
                                />
                              </b>
                            </TableCell>
                          </TableRow>,
                          this.state.salesTafelsOverPeriode.items[prop].details.map((detailProp, key) => {
                            return (
                              <TableRow key={"detail-" + prop + "-" + key}>
                                <TableCell>{detailProp.bestelling_id}</TableCell>
                                <TableCell>{detailProp.product_item}</TableCell>
                                <TableCell>{detailProp.aantal}</TableCell>
                                <TableCell>{formatValuta(detailProp.totaal)}</TableCell>
                              </TableRow>
                            );
                          }),
                        ];
                      })}
                      <TableRow className={classes.totalRow}>
                        <TableCell colSpan={"4"} />
                        <TableCell>
                          <b>
                            <TranslationWrapper
                              tDefault={"Totaal"}
                              tKey={"rapportages.rapporten.tafels.table.totaal"}
                            />
                          </b>
                        </TableCell>
                        <TableCell>{this.state.salesTafelsOverPeriode.totalen.aantal}</TableCell>
                        <TableCell>{formatValuta(this.state.salesTafelsOverPeriode.totalen.waarde)}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(null, mapDispatchToProps)(withStyles(Tafels, rapportenStyle));
